module.exports = __webpack_public_path__ + "img/balloons.1cd874a8.svg";